import React from 'react';
import format from 'date-fns/format';
import { DNAButton, DNAText, GridList, luxColors } from '@alucio/lux-ui';
import { DNADocumentContextMenu, DNADocumentThumbnail } from 'src/components/DNA';
import { DocumentORM } from 'src/types/types';
import { useAppSettings } from 'src/state/context/AppSettings';
import {
  COLUMN_CONFIG,
  FolderHeaderType,
  FolderVariants,
  GRID_LIST_STYLES_VARIANTS_CONFIGS,
} from 'src/screens/MyFolders/constants';

interface DNAFolderDocumentRowProps {
  documentORM: DocumentORM;
  variant: FolderVariants;
  onPress: (documentORM: DocumentORM) => void;
}

const DNAFolderDocumentRow: React.FC<DNAFolderDocumentRowProps> = (props) => {
  const { documentORM, variant, onPress } = props;
  const { deviceMode } = useAppSettings();
  const isTablet = deviceMode === 'tablet';
  const columns = COLUMN_CONFIG[variant].columns;

  return (
    <GridList.Row
      interactive="hoverable"
      hoverColor={luxColors.mainContainer.primary}
      onPress={() => onPress?.(documentORM)}
      style={GRID_LIST_STYLES_VARIANTS_CONFIGS.FOLDER_ROW[deviceMode]}
    >
      {columns.map(col => {
        switch (col) {
          case FolderHeaderType.FOLDER_ICON_OR_THUMBNAIL:
            return (
              <GridList.Col>
                <DNADocumentThumbnail.Hover
                  documentVersionORM={
                    documentORM.relations.version.latestPublishedDocumentVersionORM ||
                    documentORM.relations.version.latestDocumentVersionORM
                  }
                  width={GRID_LIST_STYLES_VARIANTS_CONFIGS.FOLDER_THUMBNAIL[deviceMode].width}
                  height={GRID_LIST_STYLES_VARIANTS_CONFIGS.FOLDER_THUMBNAIL[deviceMode].height}
                  showProcessing
                />
              </GridList.Col>
            )
          case FolderHeaderType.NAME:
            return (
              <GridList.Col>
                <DNAText
                  testID="folder-item-row-name"
                  numberOfLines={isTablet ? undefined : 1}
                  style={GRID_LIST_STYLES_VARIANTS_CONFIGS.TITLE_TEXT[deviceMode]}
                >
                  {documentORM.relations.version.latestPublishedDocumentVersionORM?.model.title}
                </DNAText>
              </GridList.Col>
            )
          case FolderHeaderType.UPLOADED:
            return (
              <GridList.Col>
                <DNAText
                  testID="folder-item-row-date"
                  style={GRID_LIST_STYLES_VARIANTS_CONFIGS.SECONDARY_TEXT[deviceMode]}
                >
                  {format(new Date(documentORM.model.createdAt), 'MM/dd/yyyy')}
                </DNAText>
              </GridList.Col>
            )
          case FolderHeaderType.ACTION_MENU:
            return (
              <GridList.Col>
                <DNADocumentContextMenu documentORM={documentORM}>
                  <DNAButton
                    testID="folder-item-ellipsis"
                    appearance="ghost"
                    status="subtle"
                    size={isTablet ? 'xl' : 'md'}
                    iconLeft="dots-three-vertical-bold"
                  />
                </DNADocumentContextMenu>
              </GridList.Col>
            )
          default:
            console.warn('Unsupported type', col);
            return null;
        }
      })}
    </GridList.Row>
  )
}

export default DNAFolderDocumentRow;
